import { useAddSavedColorsToCollection } from "../../add-saved-colors-to-collection";
import { useAddSavedColorsToCollectionModalStore } from "../../../js/stores/add-saved-colors-to-collection-modal-store";
import { SharedIcon } from "../shared/shared-icon";

export function AddSavedColorsToCollectionButton() {
  const {
    addSavedColorsToCollectionButtonLabel,
    getSavedColorsToCollectionUrl,
  } = useAddSavedColorsToCollection();
  const openModal = useAddSavedColorsToCollectionModalStore(
    (state) => state.openModal
  );

  return (
    <button
      className="color-collection-action color-collection-action--main"
      type="button"
      onClick={() => openModal(getSavedColorsToCollectionUrl)}
    >
      {addSavedColorsToCollectionButtonLabel}
      <SharedIcon iconName="#sprite-plus" />
    </button>
  );
}
